<lib-page-container
  [title]="title"
  [loading]="screen.isLoading()"
  [version]="appVersion.version"
  [apiVersion]="appVersion.apiVersion$ | async"
>
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button
      (buttonClick)="onBack()"
      tooltip="Back to Advertiser"
      icon="arrow_back"
    >Back</lib-button>

    <lib-button (buttonClick)="onRefresh()" tooltip="Refresh" icon="replay">Refresh</lib-button>
  </div>
  <div lib-page-body>
    <div class="migration-campaigns-container">
      <mat-tab-group
        [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
        mat-stretch-tabs="false"
        class="compact-tabs"
        mat-align-tabs="start"
      >
        <mat-tab label="Migrate Users">
          <div class="tab-content">
            <app-migrate-users-tab [advertiserId]="advertiserId"></app-migrate-users-tab>
          </div>
        </mat-tab>

        <mat-tab label="Simulate Redeem SafeBox">
          <div class="tab-content">
            <app-simulate-redeem-safebox-tab [advertiserId]="advertiserId"></app-simulate-redeem-safebox-tab>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</lib-page-container>
